module.exports = __webpack_public_path__ + "static/backgroundV1-min-eb7ba09015d0b0465fb190f979df7e3c.jpg";